import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import { savePersistedFlipState } from '../utils/flipStatePersistence';
import { RESTORE_FLIP_STATE } from '../containers/FlipMatch/constants';

const loggerMiddleware = createLogger();

const persistFlipStateMiddleware = (store) => (next) => (action) => {
    const result = next(action);
    if (action.type !== RESTORE_FLIP_STATE && (action.type === 'UPDATE_CARDS' || action.type === 'UPDATE_FLIPPED')) {
        const state = store.getState();
        const flip = state.flip || {};
        const collection = flip.collection || {};
        const collectionName = collection.name;
        const flippedCardNames = (flip.flipped || []).map((c) => c.name);
        if (collectionName) {
            savePersistedFlipState({ collectionName, flippedCardNames });
        }
    }
    return result;
};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
    composeEnhancer(
        applyMiddleware(
            thunkMiddleware,
            persistFlipStateMiddleware,
            loggerMiddleware,
        )
    )
);
export const dispatch = (params) => store.dispatch(params);
export default store;